import React, { useState } from 'react'
import {
  Form,
  Typography,
  Radio,
  Slider,
  Space,
  FormInstance,
  Switch
} from 'antd'
import DeliveryAreaSettings from '../../SameDaySettings/DeliveryAreaSettings'
import { Store } from '@slerp/controls'

const DeliveryZone = ({
  radius,
  setRadius,
  store,
  form,
  useStorePreOrderSettings,
  disabled = false
}: {
  radius: number
  setRadius: (value: number) => void
  form: FormInstance
  store: Store
  useStorePreOrderSettings?: boolean
  disabled?: boolean
}) => {
  const settings =
    useStorePreOrderSettings && store.pre_order_settings?.length
      ? store.pre_order_settings[0].delivery_area_setting
      : store.settings
  const [isCustomArea, setIsCustomArea] = useState<boolean>(
    !!settings?.delivery_area_enabled
  )
  return (
    <>
      <Form.Item
        name='delivery_area_enabled'
        initialValue={isCustomArea}
        noStyle
        hidden
      >
        <Switch disabled={disabled} />
      </Form.Item>
      <Form.Item label='Delivery zone:' className='_mb-40'>
        <Radio.Group
          defaultValue={isCustomArea ? 'custom-area' : 'radius'}
          style={{ marginBottom: '8px' }}
          onChange={(e) => {
            const isCustom = e.target.value === 'custom-area'

            form.setFieldsValue({ delivery_area_enabled: isCustom })
            setIsCustomArea(isCustom)
          }}
          disabled={disabled}
        >
          <Space direction='vertical' align='start'>
            <Radio value='radius' data-testid='delivery-zone-radius'>
              Delivery Radius
            </Radio>
            <Radio value='custom-area' data-testid='delivery-zone-area'>
              Draw My Own
            </Radio>
          </Space>
        </Radio.Group>
        <Form.Item hidden={!isCustomArea}>
          <DeliveryAreaSettings
            store={store}
            form={form}
            useStorePreOrderSettings={!!useStorePreOrderSettings}
            disabled={disabled}
          />
        </Form.Item>
        <Form.Item
          name='delivery_radius'
          style={{ margin: 0 }}
          hidden={isCustomArea}
        >
          <Slider
            step={0.1}
            min={0.1}
            max={4}
            style={{ margin: '0 8px 0 0', maxWidth: '480px' }}
            defaultValue={radius}
            onChange={(value: number) => setRadius(value)}
            disabled={disabled}
          />
        </Form.Item>
        {!isCustomArea && (
          <Typography.Paragraph>
            {radius} mile{radius !== 1 ? 's' : ''}
          </Typography.Paragraph>
        )}
      </Form.Item>
    </>
  )
}

export default DeliveryZone
